// const API_DOMAIN = 'https://eds.ispgnet.com';
// const API_DOMAIN = 'http://localhost:8050';
const API_DOMAIN = process.env.REACT_APP_API_DOMAIN;

export default API_DOMAIN;
